import script from "./RegistrationReports.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationReports.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__